import { buildUrl } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import HISTORICS from '../apiUrls';
import historicsFields from '../../fields/historicsFields';

/**
 * @param {Object} responseData
 * @param {Object[]} responseData.items
 * @param {string} responseData.items[].uuid
 * @param {string} responseData.items[].accessCode
 * @param {string} responseData.items[].createdAt
 * @param {string} responseData.items[].downloadServerIpAddressPort
 * @param {string} responseData.items[].scheduledEndDate
 * @param {string} responseData.items[].scheduledStartDate
 * @param {string} responseData.items[].downloadCodeName
 * @param {string} responseData.items[].createdBy
 * @param {Object} responseData.extraInformation
 * @param {number} responseData.totalPartialResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalPartialResults, extraInformation }) {
    const data = {};
    const mappedItems = items.map(item => ({
        [historicsFields.COMMON.UUID.key]: item[historicsFields.COMMON.UUID.key],
        [historicsFields.COMMON.ACTION_TIMESTAMP.key]: item[historicsFields.COMMON.ACTION_TIMESTAMP.key],
        [historicsFields.COMMON.ORGANIZATION_UUID.key]: item[historicsFields.COMMON.ORGANIZATION_UUID.key],
        [historicsFields.COMMON.ORGANIZATION_LEGAL_NAME.key]: item[historicsFields.COMMON.ORGANIZATION_LEGAL_NAME.key],
        [historicsFields.COMMON.ACTION_TYPE.key]: item[historicsFields.COMMON.ACTION_TYPE.key],
        [historicsFields.COMMON.USER_EMAIL.key]: item[historicsFields.COMMON.USER_EMAIL.key],
        [historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE.key]: item[historicsFields.COMMON.ATTRIBUTES_VALUES_BEFORE.key],
        [historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER.key]: item[historicsFields.COMMON.ATTRIBUTES_VALUES_AFTER.key],
        [historicsFields.COMMON.OUTCOME.key]: item[historicsFields.COMMON.OUTCOME.key],
        [historicsFields.POS_TERMINALS_HISTORICS.SERIAL_NUMBER.key]: item[historicsFields.POS_TERMINALS_HISTORICS.SERIAL_NUMBER.key],
        [historicsFields.POS_TERMINALS_HISTORICS.MANUFACTURER.key]: item[historicsFields.POS_TERMINALS_HISTORICS.MANUFACTURER.key],
        [historicsFields.POS_TERMINALS_HISTORICS.LABEL.key]: item[historicsFields.POS_TERMINALS_HISTORICS.LABEL.key],
        [historicsFields.POS_TERMINALS_HISTORICS.CUSTOM_LABEL.key]: item[historicsFields.POS_TERMINALS_HISTORICS.CUSTOM_LABEL.key]
    }));

    data.items = mappedItems;
    data.totalPartialResults = totalPartialResults;
    data.extraInformation = extraInformation;

    return data;
}

const queryGetPosTerminalsHistorics = ({ query }, enabled) => {
    return {
        queryKey: [HISTORICS.POS_TERMINALS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(HISTORICS.POS_TERMINALS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};

export default queryGetPosTerminalsHistorics;